import { defineCopy } from '@/copy';

/** cards strings. Keep the voice: short, funny, no em dashes. */
export const copy = defineCopy('cards', {
  /** Tier label of a card with no rating yet. */
  unratedTag: 'Combine pending',
  /** Funny sublines of an unrated card. One is picked per player, stable across renders. */
  unratedLines: [
    "Card's in the oven. Finish the combine.",
    'OVR loading. Go shoot something.',
    'The ref has not seen you play yet.',
    'Rating pending. Rumors only.',
  ],
  provisionalTag: 'Provisional',
  /** The medium card has no room for the long one. */
  provisionalTagShort: 'Prov',
  rustyTag: 'Rusty',
  /** {n} more games. */
  provisionalSub: "{n} more games and it's official.",
  provisionalSubOne: "1 more game and it's official.",
  rustySub: 'Last bucket: {n} days ago.',
  rustySubYesterday: 'Last bucket: yesterday.',
  rustySubToday: 'Last bucket: today.',
  rustySubUnknown: 'Last bucket: ages ago.',
  /** Ribbon texts drawn by the card for each preset. */
  ribbon: {
    rookie_card: 'Rookie',
    streetball: 'Streets',
    game_cover: 'Cover athlete',
  },
  /** Accessible names. */
  label: {
    rated: '{name}, overall {ovr}, {tier}',
    unrated: '{name}, unrated, combine pending',
    sealed: 'Sealed card. Tap to rip.',
    avatar: '{name}',
  },
  singleDigits: 'Single digits. It can only go up.',
  unknownAttr: 'Not enough games to tell yet.',
  reveal: {
    tapToRip: 'Tap to rip',
    tapToSkip: 'Tap to skip',
    sealedBack: 'Draft pick',
  },
  share: {
    button: 'Share card',
    working: 'Printing your card...',
    failed: 'The printer jammed. Try again.',
    downloaded: 'Saved. Go flex.',
    fileName: 'tts-card-{name}.png',
    fallbackName: 'player',
  },
});
